import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IInitialState {
  previousAssets: any;
  currentAssets: any;
}

const initialState: IInitialState = {
  previousAssets: null,
  currentAssets: [],
};

const advisorLiquidityReducer = createSlice({
  name: "[advisorLiquidity]",
  initialState,
  reducers: {
    setPreviousAssets: (state, action: PayloadAction<any>) => {
      state.previousAssets = action.payload;
    },
    setCurrentAssets: (state, action: PayloadAction<any>) => {
      state.currentAssets = action.payload;
    },
    resetLiquidityReducer: () => initialState,
  },
});

export const {
  setPreviousAssets,
  setCurrentAssets,
  resetLiquidityReducer,
} = advisorLiquidityReducer.actions;

export default advisorLiquidityReducer.reducer;
